import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { nameWithPossesive } from 'utils/string';
import { useHistory } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as OwlHeading } from 'assets/images/owl-heading-share.svg';
import { useTranslation } from 'react-i18next';
import { sendAnalyticsPath, sendAnalyticsEvent } from 'utils/analyticsWrapper';
import closeBtn from 'assets/images/close-button.svg';
import Avatar from 'components/shared/Goal/Avatar';
import './styles.css';

const ShareProfilePopUp = (props) => {
  const { user, goal } = props;

  const { t } = useTranslation();

  sendAnalyticsPath('user/username/goalname/share');

  const userProfileLink = `${process.env.REACT_APP_API_SITE_URL}/user/${encodeURI(user.userName)}/${goal.alias}`;

  const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${userProfileLink}`;

  const twitterLink = `http://twitter.com/share?url=${userProfileLink}&hashtags=goalsetter&text=${encodeURI(t('tweet_description'))}`;

  const browserHistory = useHistory();

  const copyLinkMessage = useRef(null);

  const firstNameWithPossesive = user.firstnameWithPossesive.trim();

  const onLinkCopied = () => {
    sendAnalyticsEvent('Goal Share Popup', 'goal_share_link_copied');

    copyLinkMessage.current.classList.toggle('show');

    setTimeout(() => {
      copyLinkMessage.current.classList.toggle('show');
    }, 2000);
  };

  const onClick = (e, fromSource, toLink) => {
    if (fromSource === 'facebook') {
      sendAnalyticsEvent('Goal Share Popup', 'goal_share_at_facebook');
    }
    if (fromSource === 'twitter') {
      sendAnalyticsEvent('Goal Share Popup', 'goal_share_at_twitter');
    }
    if (fromSource === 'email') {
      sendAnalyticsEvent('Goal Share Popup', 'goal_share_at_email');
    }
  };

  const onClose = () => {
    sendAnalyticsEvent('Goal Share Popup', 'goal_share_popup_closed');

    if (props.onClose) {
      props.onClose();
    }

    browserHistory.goBack();
  };

  if (props.show === false) {
    return null;
  }

  return (
    <div
      className="alert-popup-overlay"
      style={{ display: 'flex', opacity: 1 }}
    >
      <div className="alert-popup popup-details info share-profile">
        <div className="heading-graphic">
          <OwlHeading style={{ height: '42px', width: '265px' }} />
        </div>
        <a className="close-button pointer" onClick={onClose}>
          <span
            className="icon-svg icon-close-button pointer"
            style={{
              maskImage: `url(${closeBtn})`,
              WebkitMaskImage: `url(${closeBtn})`,
            }}
          />
        </a>
        <h3>
          {t('share_user_goals_title', { firstNameWithPossesive })}
        </h3>
        <p>{t('share_goal_description')}</p>

        <div
          className="profile-link just-been-copied copy-button"
          style={{ justifyContent: 'center', paddingTop: '5px' }}
        >
          <div style={{ textAlign: 'center' }} />
          <div
            style={{
              minHeight: 0, border: 0, marginBottom: 0, marginRight: 10,
            }}
            className="dashboard-card goalcard finished"
          >
            <Avatar goal={goal} aloneView={false} />
          </div>

          <CopyToClipboard text={userProfileLink} onCopy={onLinkCopied}>
            <a type="button" className="copy-buttons" style={{ width: 'auto' }}>
              <div>{t('copygoal_title')}</div>
              <div ref={copyLinkMessage} className="copy-notification">
                {t('copied_title')}
              </div>
            </a>
          </CopyToClipboard>
        </div>

        <div className="alert-popup-socials">
          <div className="center">{t('share_socialmedia_title')}</div>
          <ul>
            <li className="facebook">
              <a
                href={facebookLink}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => onClick(e, 'facebook')}
                className="fa fa-facebook"
                alt="Share on Facebook"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
            </li>
            <li className="twitter">
              <a
                rel="noopener noreferrer"
                target="_blank"
                onClick={(e) => onClick(e, 'twitter')}
                href={twitterLink}
                className="fa fa-twitter"
                alt="Twitter share"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
            </li>
            <li className="email">
              <a
                href="mailto:info@goalsetter.co"
                onClick={(e) => onClick(e, 'email')}
                className="fa fa-envelope"
                rel="noopener noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  goal: state.publicProfile.goal,
  user: state.publicProfile.information,
});

export default connect(
  mapStateToProps,
)(ShareProfilePopUp);
